<div class="chart-circle-gauge">
    <highcharts-chart 
        [Highcharts]="hc"
        [options]="chartOptions"
        (chartInstance)="chartInit($event)"
        [style.display]="'block'"
        [style.width.%]="100"
    ></highcharts-chart>
</div>